import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=5a264d10&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./AppHeader.vue?vue&type=style&index=0&id=5a264d10&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./AppHeader.vue?vue&type=style&index=1&id=5a264d10&prod&lang=scss&scoped=true")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5a264d10",
  "00ddf5ad"
  
)

export default component.exports